import { FC } from "react";
import * as HoverCard from "@radix-ui/react-hover-card";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";

interface Props {
    trigger?: React.ReactNode;
    sideValue: "top" | "right" | "bottom" | "left";
    children: React.ReactNode;
    showContent?: boolean | "" | null | undefined;
    className?: string;
    cursorType?: string;
}

const PopupCard: FC<Props> = ({
    trigger,
    sideValue,
    children,
    showContent = true,
    className,
    cursorType = "cursor-help",
}: Props) => {
    return (
        <HoverCard.Root openDelay={200}>
            <HoverCard.Trigger
                color="white"
                className={`${cursorType} inline-flex items-center ${
                    !showContent && "pointer-events-none"
                }`}
            >
                {trigger ? (
                    trigger
                ) : (
                    <QuestionMarkCircleIcon className="size-4 text-text" />
                )}
            </HoverCard.Trigger>
            {showContent && (
                <HoverCard.Portal>
                    <HoverCard.Content
                        side={sideValue}
                        sideOffset={8}
                        className={`border-primary-gray rounded-xl border bg-background-lighter p-6 text-text shadow-2xl ${className}`}
                    >
                        {children}
                        <HoverCard.Arrow className="fill-background-lighter" />
                    </HoverCard.Content>
                </HoverCard.Portal>
            )}
        </HoverCard.Root>
    );
};

export default PopupCard;
